import { BodyStyles } from '~/contracts/flp';

type OwnProps = {
  downPayment?: number;
  monthlyPayment?: number;
  sortBy?: 'MostPopular' | 'LowestPrice' | 'CashDue' | 'MonthlyPayment';
  bodyStyles?: BodyStyles[];
};

// todo(2024/11): move these out of an object so they can all be optional parameters
export function getCvnaIdFinanceFilters({
  downPayment,
  monthlyPayment,
  sortBy,
  bodyStyles
}: OwnProps) {
  /* HACK: a loose null comparison x != null covers both null & undefined, while allowing integer values */
  const filters = {
    filters: {
      ...(Boolean(bodyStyles) && { bodyStyles }),
      ...((downPayment != null || monthlyPayment != null) && {
        finance: {
          ...(downPayment != null && { downPayment }),
          ...(monthlyPayment != null && { monthlyPayment })
        }
      })
    },
    ...(Boolean(sortBy) && { sortBy })
  };

  return btoa(JSON.stringify(filters));
}
